module.exports = __webpack_public_path__ + "img/dropdown_arrow_green.dbc0f3c6.svg";